import { api } from "@/lib/api"
import type { Lease } from "@rentbase/shared"

export const leasesService = {
  async list(property_id?: string): Promise<Lease[]> {
    const params = property_id ? { property_id } : {}
    const { data } = await api.get("/api/leases", { params })
    return data.data
  },
  async get(id: string): Promise<Lease> {
    const { data } = await api.get(`/api/leases/${id}`)
    return data.data
  },
  async create(input: Record<string, unknown>): Promise<Lease> {
    const { data } = await api.post("/api/leases", input)
    return data.data
  },
  async update(id: string, input: Record<string, unknown>): Promise<Lease> {
    const { data } = await api.put(`/api/leases/${id}`, input)
    return data.data
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/api/leases/${id}`)
  },
  async unassign(id: string): Promise<Lease> {
    const { data } = await api.post(`/api/leases/${id}/unassign`)
    return data.data
  },
  async reactivate(id: string): Promise<Lease> {
    const { data } = await api.post(`/api/leases/${id}/reactivate`)
    return data.data
  },
}
